<template>
    <div 
        v-if="hasHeader || showImportantDisclosure" 
        class="mb-3 d-flex justify-content-between align-items-start align-items-md-center flex-column flex-md-row gap-2" 
        :class="{ 'mb-md-5': hasHeader }"
    >
        <template v-if="hasHeader">
            <h1 v-if="isFirstSlice" class="mb-3 h2 mb-md-0">{{ h2 }}</h1>
            <h2 v-else class="mb-3 mb-md-0">{{ h2 }}</h2>
        </template>
        <important-disclosure v-if="showImportantDisclosure" />
    </div>
</template>

<script>
import ImportantDisclosure from '@/components/ImportantDisclosure.vue';

export default {
    components: {
        ImportantDisclosure
    },
    props: {
        h2: {
            type: String,
            required: true
        },
        showImportantDisclosure: {
            type: Boolean,
            required: true
        },
        isFirstSlice: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        hasHeader() {
            return this.h2.length > 0;
        }
    }
};
</script>